import BalanceAdjustments from "@/components/financiero/balances/BalanceAdjustments";

export default function GestionBalancesPanel({ empresa, onApplied, onClose }) {
    const empresaId = Number(empresa?.empresa_id ?? empresa?.id);
    const clientes = Array.isArray(empresa?.clientes) ? empresa.clientes : [];

    return (
        <div className="border rounded-xl shadow-sm p-6 bg-white">
            <h3 className="text-lg font-semibold text-gray-800 border-b pb-4 mb-6">
                Ajustes de Balance
            </h3>

            <BalanceAdjustments
                empresaId={empresaId}
                clientes={clientes}
                onDone={onApplied}
                onClose={onClose}
            />
        </div>
    );
}
